<div class="impacts-header">
  <div class="impacts-title">Impacts</div>
  <div class="impacts-line"></div>
  <div class="impacts-subtitle">driving positive change is a foundational aspect of the company’s mission.</div>
</div>
<div *ngIf="!impacts"><app-spinner></app-spinner></div>
<div *ngIf="impacts" class="impacts-main">
  <div class="impacts-content">
    <tyt-company-impact-item *ngFor="let item of impactsFirstSection" [impact]="item"></tyt-company-impact-item>
    <div *ngIf="showEmbeddedOffers" class="impacts-embedded-offer">
      <tyt-embedded-offer-set [offerSetID]="offerSetID" [email]="''" [firstName]="''" [showNoThanks]="0"></tyt-embedded-offer-set>
    </div>
    <tyt-company-impact-item *ngFor="let item of impactsSecondSection" [impact]="item"></tyt-company-impact-item>
  </div>
</div>
<tyt-call-to-action [callToAction]="c2a"></tyt-call-to-action>